import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Define supported languages
export const SUPPORTED_LANGUAGES = {
  en: 'English',
  fr: 'Français',
} as const;

export type SupportedLanguage = keyof typeof SUPPORTED_LANGUAGES;

// Language detection options
const detectionOptions = {
  // Order of detection methods
  order: ['localStorage', 'navigator', 'htmlTag'],
  // Keys to lookup language from
  lookupLocalStorage: 'i18nextLng',
  // Cache user language
  caches: ['localStorage'],
  // Exclude cookies for privacy
  excludeCacheFor: ['cimode'],
};

i18n
  // Load translations using http backend
  .use(HttpBackend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Fallback language
    fallbackLng: 'en',
    // Supported languages
    supportedLngs: ['en', 'fr'],
    // Preload both languages so switching doesn't trigger Suspense remount
    preload: ['en', 'fr'],
    // Debug mode (disable in production)
    debug: process.env.NODE_ENV === 'development',
    // Language detection options
    detection: detectionOptions,
    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation'],
    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    // Backend configuration for loading translations
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    // React-specific options
    react: {
      useSuspense: true, // Enable Suspense for async loading
    },
    // Return empty string for missing keys in production
    returnEmptyString: process.env.NODE_ENV === 'production',
    // Load translation files on init
    partialBundledLanguages: true,
  });

export default i18n;
